import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// 验证码文档：https://cloud.tencent.com/document/product/295/6616
import imlog, { LEVELS } from '@tencent/imlog';

var EduCaptcha = /*#__PURE__*/function () {
  function EduCaptcha(appId) {
    var _this = this;

    _classCallCheck(this, EduCaptcha);

    _defineProperty(this, "waitForScriptLoad", function () {
      var count = 0;
      var timerId;
      clearTimeout(timerId);
      return new Promise(function (resolve, reject) {
        var startInterval = function startInterval() {
          timerId = setTimeout(function () {
            if (window.TencentCaptcha) {
              clearTimeout(timerId);
              resolve();
            } else {
              count++;

              if (count > 20) {
                clearTimeout(timerId);

                _this.Logger.error('wait for captcha script load timeout');

                reject(new Error('captcha script load timeout'));
              } else {
                startInterval();
              }
            }
          }, 80);
        };

        startInterval();
      });
    });

    this.appId = appId;
    this.codeTimer = null;
    this.isScriptLoad = false;
    var Logger = imlog.createLogger('@tencent/edu-captcha'); // Logger.config({
    //   project: 'edu-captcha',
    //   biz_id: 'k12',
    //   logger: { autoUpload: 30 },
    //   uin: `${getUin()}`,
    // });

    Logger.config({
      autoUpload: LEVELS.info
    });
    this.Logger = Logger;
    this.init();
  }

  _createClass(EduCaptcha, [{
    key: "init",
    value: function init() {
      if (typeof window !== 'undefined' && !window.TencentCaptcha) {
        this.loadCapScript();
      }
    }
  }, {
    key: "loadCapScript",
    value: function loadCapScript(reload) {
      var _this2 = this;

      this.isScriptLoad = true;
      return new Promise(function (resolve, reject) {
        if (window.TencentCaptcha) return true;
        var script = document.createElement('script');

        script.onload = function () {
          if (window.TencentCaptcha) {
            _this2.Logger.info('load tencent captcha success');
          } else {
            // 怀疑验证码组件执行失败
            // 怀疑有运营商劫持问题，这里做个降级并上报脚本内容
            script.onerror();

            _this2.Logger.error('load tencent captcha fail');
          }

          resolve();
        };

        script.onerror = function (err) {
          if (reload) {
            if (err) {
              _this2.Logger.error("load tencent captcha fail with error ".concat(err));

              reject(err);
            }
          } else {
            _this2.loadCapScript(true);
          }
        };

        script.type = 'text/javascript';
        script.src = 'https://ssl.captcha.qq.com/TCaptcha.js';
        document.getElementsByTagName('head')[0].appendChild(script);
      });
    }
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.Logger.info('show captcha');
                clearTimeout(this.codeTimer);
                this.codeTimer = setTimeout(function () {
                  _this3.Logger.info('show captcha timeout');
                }, 15 * 1000); // 防止忘记预加载验证码js

                if (window.TencentCaptcha) {
                  _context.next = 18;
                  break;
                }

                console.warn('尚未加载验证码资源，正在加载。。。');
                _context.prev = 5;

                if (!this.isScriptLoad) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return this.waitForScriptLoad();

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return this.loadCapScript();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 18:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  // eslint-disable-next-line no-undef
                  var captchaInstance = new TencentCaptcha(_this3.appId, function (res) {
                    if (res.ret === 0 || res.ret === 2) {
                      _this3.Logger.info(res.ret === 0 ? 'show captcha success' : 'cancel captcha');

                      resolve(res);
                    } else {
                      _this3.Logger.error('new TencentCaptcha callback error');

                      reject(res);
                    }
                  }, {
                    ready: function ready() {
                      _this3.Logger.info('show TencentCaptcha');

                      clearTimeout(_this3.codeTimer);
                    },
                    needFeedBack: false
                  });
                  captchaInstance.show(); // 显示验证码
                }));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 15]]);
      }));

      function show() {
        return _show.apply(this, arguments);
      }

      return show;
    }()
  }]);

  return EduCaptcha;
}();

export { EduCaptcha as default };